export default __webpack_public_path__ + "static/media/whatsapp_purple_icon.a2d789f5.svg";